import React from 'react';

import Title from '../../Components/Admin/Title';

import { Link, useNavigate } from 'react-router-dom';

import { FaBullseye } from "react-icons/fa";

import useFetchApi from '../../hooks/useFetchApi';

import usePagination from '../../hooks/usePagination';

import Swal from 'sweetalert2';

import {
    PURPOSE_DATA_FETCH_ADMIN_URL,
    PURPOSE_DATA_EDIT_ADMIN_URL,
} from '../../utils/Constant';

import { authHeaders } from '../../utils/api';


function Purpose() {

    const navigate = useNavigate();


    // =========================
    // FETCH PURPOSES
    // =========================

    const {
        data,
        loading,
        error
    } = useFetchApi({
        url: PURPOSE_DATA_FETCH_ADMIN_URL,
        dataKey: 'purposes',
        authType: 'admin',
    });


    console.log("Purpose Data:", data);


    // =========================
    // PAGINATION
    // =========================

    const {
        currentItems,
        getVisiblePages,
        currentPage,
        setCurrentPage,
        handlePrev,
        handleNext,
    } = usePagination({
        data,
        itemShowPerPage: 5
    });


    // =========================
    // EDIT
    // =========================

    const handleEdit = (id) => {

        navigate(`/admin/purposes/edit/${id}`);

    };


    // =========================
    // DELETE
    // =========================

    const handleDelete = async (id) => {

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });


        if (!confirm.isConfirmed) {
            return;
        }


        try {

            const res = await fetch(
                PURPOSE_DATA_EDIT_ADMIN_URL(id),
                {
                    method: 'DELETE',

                    headers: {
                        ...authHeaders(),
                        Accept: 'application/json',
                    }
                }
            );


            const result = await res.json();


            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: result.message || 'Delete failed',
                });

                return;
            }


            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: result.message,
                timer: 2000,
                showConfirmButton: false,
            });


            // Refresh data
            window.location.reload();


        } catch (error) {

            console.error("Delete Error:", error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });

        }

    };


    // =========================
    // LOADING
    // =========================

    if (loading) {

        return (
            <>

                <Title
                    icon={FaBullseye}
                    title="Purposes"
                />

                <div className="bg-white rounded shadow-lg mt-5 p-5">

                    <p>
                        Loading...
                    </p>

                </div>

            </>
        );

    }


    // =========================
    // ERROR
    // =========================

    if (error) {

        return (
            <>

                <Title
                    icon={FaBullseye}
                    title="Purposes"
                />

                <div className="bg-white rounded shadow-lg mt-5 p-5">

                    <p className="text-red-500">
                        {error}
                    </p>

                </div>

            </>
        );

    }


    return (
        <>

            {/* =========================
                PAGE TITLE
            ========================= */}

            <Title
                icon={FaBullseye}
                title="Purposes"
            />


            {/* =========================
                MAIN CARD
            ========================= */}

            <div className="bg-white rounded shadow-lg mt-5">


                {/* =========================
                    CARD HEADER
                ========================= */}

                <h4 className="text-lg p-4 font-semibold border-b flex justify-between items-center">

                    <span>
                        Purposes
                    </span>


                    <Link
                        to="/admin/purposes/create"
                        className="btn btn-accent btn-sm text-white shadow-md"
                    >
                        Add Purpose
                    </Link>

                </h4>


                {/* =========================
                    TABLE
                ========================= */}

                <div className="p-4">

                    <table className="border w-full">


                        {/* =========================
                            TABLE HEADER
                        ========================= */}

                        <thead className="bg-gray-400 border p-2">

                            <tr className="border p-2">

                                <th className="border p-2">
                                    Sl No.
                                </th>

                                <th className="border p-2">
                                    Name
                                </th>

                                <th className="border p-2">
                                    Status
                                </th>

                                <th className="border p-2">
                                    Action
                                </th>

                            </tr>

                        </thead>


                        {/* =========================
                            TABLE BODY
                        ========================= */}

                        <tbody className="border p-2">

                            {currentItems.map((item, index) => {

                                const {
                                    id,
                                    name,
                                    status_label,
                                    status_badge
                                } = item;


                                return (

                                    <tr
                                        className="border p-2"
                                        key={id}
                                    >


                                        {/* SL NO */}

                                        <td className="border p-2 text-sm">

                                            {index + 1}

                                        </td>


                                        {/* NAME */}

                                        <td className="border p-2 text-sm">

                                            {name}

                                        </td>


                                        {/* STATUS */}

                                        <td className="border p-2 text-sm">

                                            <span
                                                className={`badge badge-${status_badge} badge-outline`}
                                            >
                                                {status_label}
                                            </span>

                                        </td>


                                        {/* ACTION */}

                                        <td className="border p-2 text-sm">

                                            <div className="dropdown dropdown-end">


                                                <div
                                                    tabIndex={0}
                                                    role="button"
                                                    className="btn btn-xs btn-info m-1"
                                                >
                                                    Action
                                                </div>


                                                <ul
                                                    tabIndex={0}
                                                    className="
                                                        dropdown-content
                                                        menu
                                                        bg-base-100
                                                        rounded-box
                                                        z-[1]
                                                        w-52
                                                        p-2
                                                        shadow
                                                    "
                                                >


                                                    {/* EDIT */}

                                                    <li>

                                                        <button
                                                            onClick={() => handleEdit(id)}
                                                            className="text-green-500"
                                                        >
                                                            Edit
                                                        </button>

                                                    </li>


                                                    {/* DELETE */}

                                                    <li>

                                                        <button
                                                            onClick={() => handleDelete(id)}
                                                            className="text-red-500"
                                                        >
                                                            Delete
                                                        </button>

                                                    </li>


                                                </ul>

                                            </div>

                                        </td>

                                    </tr>

                                );

                            })}

                        </tbody>

                    </table>


                    {/* =========================
                        PAGINATION
                    ========================= */}

                    <div className="paginationContiner flex justify-between items-center my-4">


                        {/* PREVIOUS */}

                        <button
                            className="btn btn-outline"
                            onClick={handlePrev}
                        >
                            Prev
                        </button>


                        {/* PAGE NUMBERS */}

                        <div className="join">

                            {getVisiblePages().map((page) => (

                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`
                                        join-item
                                        btn
                                        btn-sm
                                        ${currentPage === page
                                            ? "btn-primary text-white"
                                            : "btn-outline"
                                        }
                                    `}
                                >
                                    {page + 1}
                                </button>

                            ))}

                        </div>


                        {/* NEXT */}

                        <button
                            className="btn btn-outline"
                            onClick={handleNext}
                        >
                            Next
                        </button>


                    </div>

                </div>

            </div>

        </>

    );

}


export default Purpose;